// src/components/stats/PlayerAvatar.jsx -- player headshot with initials fallback.
// Mirrors src/components/TeamLogo.jsx: external <img> + onError -> fallback. The
// fallback is the initials gradient circle previously inline in PlayerHeader.
// URL from headshotUrl(playerId, league); null id / unknown league / load error
// -> initials. Display-only, no data dependency. Spec 2026-08-13-998 PR1.

import { useState } from 'react';
import { headshotUrl } from '../../lib/player-stats-display';

function initials(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export default function PlayerAvatar({ playerId, league, name, size = 48 }) {
  const src = headshotUrl(playerId, league);
  const [err, setErr] = useState(false);
  // Reset the error gate when the player (src) changes -- state-during-render
  // (not useEffect, which would flash the stale initials for one paint). Without
  // this, a reused instance (StatsPage renders PlayerHeader with no key) keeps a
  // prior player's 404 err=true and wrongly shows initials for the next player.
  const [prevSrc, setPrevSrc] = useState(src);
  if (src !== prevSrc) {
    setPrevSrc(src);
    setErr(false);
  }
  if (!src || err) {
    return (
      <div aria-hidden="true" style={{
        width: size, height: size, borderRadius: '50%', flexShrink: 0,
        background: 'linear-gradient(135deg,#1d4ed8,#4f46e5)', color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontWeight: 800, fontSize: size / 3, letterSpacing: 0.5,
      }}>
        {initials(name)}
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={name || ''}
      width={size}
      height={size}
      onError={() => setErr(true)}
      style={{ borderRadius: '50%', flexShrink: 0, objectFit: 'cover', background: '#1e293b' }}
    />
  );
}
